export const APPLICANT_AUTOMATION_COMMUNICATION_TYPES: Record<
  ApplicantAutomationCommunicationType,
  ApplicantAutomationCommunicationType
> = Object.freeze({
  INTERVIEW_REMINDER: 'INTERVIEW_REMINDER',
  STATUS_CHANGE: 'STATUS_CHANGE',
  WORK_HISTORY: 'WORK_HISTORY',
  INTEREST_CONFIRMATION: 'INTEREST_CONFIRMATION',
  FIRST_DAY_REMINDER: 'FIRST_DAY_REMINDER',
});

export const CONFIGURATION_MESSAGE_TYPES = Object.freeze({
  ...APPLICANT_AUTOMATION_COMMUNICATION_TYPES,
  STATUS_CHANGE_INTERVIEWING: 'STATUS_CHANGE_INTERVIEWING',
  STATUS_CHANGE_REJECTED: 'STATUS_CHANGE_REJECTED',
  STATUS_CHANGE_INITIAL_OUTREACH: 'STATUS_CHANGE_INITIAL_OUTREACH',
  STATUS_CHANGE_SAVED: 'STATUS_CHANGE_SAVED',
});

export type CreatableApplicantAutomationTypes = keyof typeof CREATABLE_APPLICANT_AUTOMATION_TYPES;
export const CREATABLE_APPLICANT_AUTOMATION_TYPES = Object.freeze({
  ...APPLICANT_AUTOMATION_COMMUNICATION_TYPES,
  STATUS_CHANGE_APPLIED: 'STATUS_CHANGE_APPLIED',
  STATUS_CHANGE_ACCEPTED: 'STATUS_CHANGE_ACCEPTED',
  STATUS_CHANGE_PHONE_INTERVIEWING: 'STATUS_CHANGE_PHONE_INTERVIEWING',
  STATUS_CHANGE_INTERVIEWING: 'STATUS_CHANGE_INTERVIEWING',
  STATUS_CHANGE_VALIDATING: 'STATUS_CHANGE_VALIDATING',
  STATUS_CHANGE_REJECTED: 'STATUS_CHANGE_REJECTED',
  STATUS_CHANGE_SAVED: 'STATUS_CHANGE_SAVED',
});

export const APPLICANT_AUTOMATION_DISPLAY_CONDITION_TYPES: Record<
  ApplicantAutomationDisplayCondition,
  ApplicantAutomationDisplayCondition
> = Object.freeze({
  INOVA_SUBSCRIPTION: 'INOVA_SUBSCRIPTION',
});
